module.exports = __webpack_public_path__ + "static/media/logo-dd.7604912c.svg";